export default __webpack_public_path__ + "static/media/google-horizontal.0c4515fe.svg";